const MIN_CHASSIE_LENGTH = 17;
const MAX_CHASSIE_LENGTH = 19;

function normalizeChassie(chassie = '') {
  return `${chassie}`.trim();
}

function isValidChassie(chassie = '') {
  const normalizedChassie = normalizeChassie(chassie);

  return normalizedChassie.length >= MIN_CHASSIE_LENGTH &&
    normalizedChassie.length <= MAX_CHASSIE_LENGTH;
}

export {
  MIN_CHASSIE_LENGTH,
  MAX_CHASSIE_LENGTH,
  isValidChassie,
};
